import * as React from 'react';

import classnames from 'classnames';
// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import styles from './trial-limits-table.module.css';

type TableRowProps = {
    feature: any;
};

export function TableRow(props: TableRowProps) {
    const {feature} = props;
    const {
        humanReadableType,
        currentUsage,
        foundationLimit,
        proLimit,
        businessLimit,
        enterpriseLimit,
    } = feature;

    return (
        <div className={styles.row}>
            <div className={classnames(styles.title, styles.text)}>
                {capitalize(humanReadableType)}
            </div>
            <div className={classnames(styles.cell, styles.text)}>
                <span className={currentUsage <= foundationLimit ? undefined : styles.orange}>
                    {currentUsage}
                </span>
            </div>
            <div className={classnames(styles.cell, styles.text)}>
                {typeof foundationLimit === 'number' ? foundationLimit : 'Unlimited'}
            </div>
            <div className={classnames(styles.cell, styles.text)}>
                {typeof proLimit === 'number' ? proLimit : 'Unlimited'}
            </div>
            <div className={classnames(styles.cell, styles.text)}>
                {typeof businessLimit === 'number' ? businessLimit : 'Unlimited'}
            </div>
            <div className={classnames(styles.cell, styles.text)}>
                {typeof enterpriseLimit === 'number' ? enterpriseLimit : 'Unlimited'}
            </div>
        </div>
    );
}
